import { render, staticRenderFns } from "./diklat_struktural.vue?vue&type=template&id=bab5570c&"
import script from "./diklat_struktural.vue?vue&type=script&lang=js&"
export * from "./diklat_struktural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports